import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Radio } from 'shared/components';
import { AddPerson } from 'features/tc-renewal';
import './SecurityQuestion.scss';

const YES_VALUE = 'Yes';
const NO_VALUE = 'No';

class SecurityQuestion extends Component {
  constructor(props) {
    super(props);

    this.labels = {
      sectionTitle: '',
      modalMessage: '',
      buttonLabel: 'testCenter.securityInfo.labelAddPerson',
      editSaveLabels: {
        modalAddTitle: 'testCenter.securityInfo.labelAddIndividualTitle',
        modalEditTitle: 'testCenter.securityInfo.labelEditPerson',
        modalAddButton: 'testCenter.securityInfo.labelAddIndividual',
        modalSaveButton: 'testCenter.securityInfo.labelSaveIndividual',
      },
    };

    this.state = {
      checkedValue: props.listOfPersons.length ? NO_VALUE : YES_VALUE,
    };

    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.removeSuccessMessage = this.removeSuccessMessage.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { onSelectionChange, name } = this.props;

    if (
      this.props.listOfPersons &&
      prevProps.listOfPersons &&
      this.props.listOfPersons.length !== prevProps.listOfPersons.length
    ) {
      this.setState((prevState) => {
        let checkedValue =
          prevState.checkedValue === NO_VALUE
            ? prevState.checkedValue
            : this.props.listOfPersons.length
            ? NO_VALUE
            : YES_VALUE;
        onSelectionChange(name, checkedValue);
        return {
          checkedValue: checkedValue,
        };
      });
    }
  }

  onSelectionChange(e) {
    const { value } = e.target;
    const { onSelectionChange, name } = this.props;

    this.setState({
      checkedValue: value,
    });

    onSelectionChange(name, value);
  }

  removeSuccessMessage() {
    this.setState({
      showSuccessMessage: false,
      successMessage: '',
    });
  }

  render() {
    const { question, listOfPersons } = this.props;

    this.labels.sectionTitle = this.props.sectionTitle;
    this.labels.modalMessage = this.props.modalMessage;

    return (
      <div className="border-gray">
        <div className="question">
          <span className="question-data">{this.props.t(question)}</span>
          <span className="question-buttons">
            <div className="form-check form-check-inline">
              <div className="radio-input">
                <Radio
                  value={YES_VALUE}
                  label={this.props.t('common.labels.yes')}
                  checked={this.state.checkedValue === YES_VALUE}
                  onChange={this.onSelectionChange}
                />
              </div>
            </div>

            <div className="form-check form-check-inline">
              <div className="radio-input">
                <Radio
                  value={NO_VALUE}
                  label={this.props.t('common.labels.no')}
                  checked={this.state.checkedValue === NO_VALUE}
                  onChange={this.onSelectionChange}
                />
              </div>
            </div>
          </span>
        </div>
        {this.state.checkedValue === NO_VALUE && (
          <AddPerson
            {...this.props}
            labels={this.labels}
            personRequired
            hideAddButton={listOfPersons.length ? true : false}
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(SecurityQuestion);
SecurityQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  responsible: PropTypes.string.isRequired,
  contactType: PropTypes.string.isRequired,
  modalMessage: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  contactTypeId: PropTypes.number.isRequired,
  alternateContact: PropTypes.shape({}).isRequired,
  listOfPersons: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateContactsList: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
};
